// src/components/CreateUser.js
import React, { useState } from 'react';

import apiClient from '../services/apiClient';
const CreateUser = ({ onUserCreated }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [phone, setPhone] = useState('');
  const [role, setRole] = useState('customer');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('token');
    try {
      await apiClient.post('/auth/signup', { name, email, password, phone, role }, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      setMessage('User created successfully!');
      setName('');
      setEmail('');
      setPassword('');
      setPhone('');
      setRole('customer');
      if (onUserCreated) {
        onUserCreated();
      }
    } catch (error) {
      setMessage('Failed to create user. Check if email already exists.');
    }
  };

  return (
    <div className="p-4 md:p-6 bg-white shadow-md rounded-lg">
      <div className="flex items-center justify-center gap-3 mb-6">
          <div className="h-8 w-2 bg-green-500 rounded-full"></div>
          <h2 className="text-2xl md:text-3xl font-bold text-gray-800 tracking-tight text-center">Create New User Account</h2>
      </div>
      <form onSubmit={handleSubmit} className="space-y-4">
        <input type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder="Full Name" className="w-full p-2 border rounded-md" required />
        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" className="w-full p-2 border rounded-md" required />
        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" className="w-full p-2 border rounded-md" required />
        <input type="tel" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="Phone Number" className="w-full p-2 border rounded-md" required />
        <select value={role} onChange={(e) => setRole(e.target.value)} className="w-full p-2 border rounded-md">
          <option value="customer">Customer</option>
          <option value="delivery">Delivery Partner</option>
          <option value="admin">Admin</option>
          <option value="franchise">Franchise</option>
        </select>
        {role === 'franchise' && (
          <p className="text-xs text-gray-500 -mt-2">
            This only creates the login. Go to "Manage Franchises" afterward to link pincodes, commission rate, and location.
          </p>
        )}
        <div className="flex justify-center mt-6">
          <button type="submit" className="w-full md:w-auto px-12 py-3 bg-blue-600 text-white rounded-lg font-bold shadow-md hover:bg-blue-700 hover:shadow-lg transition-all">Create Account</button>
        </div>
      </form>
      {message && <p className="mt-4 text-center text-sm">{message}</p>}
    </div>
  );
};

export default CreateUser;